module.exports = __webpack_public_path__ + "static/img/foil.9aff162.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/foil.png
// module id = shkn
// module chunks = 1